import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export let DeleteContactThunk = createAsyncThunk(
	'contact/DeleteContactThunk',
	async (arg, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let res = await axios.delete(
				`https://api.act2hf.com/admin/contact_us/${arg?.id}`,
			);

			return res.data;
		} catch (error) {
			// console.log(error.response.data);
			return rejectWithValue(error.response.data);
		}
	},
);
